module.exports = __webpack_public_path__ + "img/nmjs.a55020b1.png";